/* eslint-disable import/no-named-as-default */
/* eslint-disable no-shadow */
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  loadingSubscriptionPlans,
  loadMonthlySubscriptionPlans,
  toggleTermsModal,
} from "../../actions/subscriptionPlansActions";
import FullScreenLoading from "../shared/loaders/FullScreenLoading";
import MonthlyPlansList from "./MonthlyPlansList";
import planType from "./types/planType";

export class Monthly extends Component {
  componentDidMount() {
    const { loadMonthlySubscriptionPlans, loadingSubscriptionPlans } =
      this.props;
    loadingSubscriptionPlans();
    loadMonthlySubscriptionPlans();
  }

  render() {
    const { loading, monthly, termsMonthly, toggleTermsModal } = this.props;

    return (
      <Fragment>
        {loading ? (
          <FullScreenLoading />
        ) : (
          <MonthlyPlansList
            monthly={monthly || []}
            termsMonthly={termsMonthly}
            toggleTermsModal={toggleTermsModal}
          />
        )}
      </Fragment>
    );
  }
}

Monthly.propTypes = {
  loading: PropTypes.bool.isRequired,
  loadingSubscriptionPlans: PropTypes.func.isRequired,
  loadMonthlySubscriptionPlans: PropTypes.func.isRequired,
  monthly: PropTypes.arrayOf(planType),
  termsMonthly: PropTypes.string,
  toggleTermsModal: PropTypes.func.isRequired,
};

Monthly.defaultProps = {
  monthly: PropTypes.isNull,
  termsMonthly: PropTypes.isNull,
};

const mapStateToProps = (state) => ({
  loading: state.subscriptionPlans.loading,
  monthly: state.subscriptionPlans.monthly,
  termsMonthly: state.subscriptionPlans.termsMonthly,
});

export default connect(mapStateToProps, {
  toggleTermsModal,
  loadingSubscriptionPlans,
  loadMonthlySubscriptionPlans,
})(Monthly);
